import React, { useState, useEffect, useRef } from 'react';

// --- DATA CONFIGURATION ---
// กำหนดข้อมูลของแต่ละ Target ที่นี่ (อ้างอิงตาม Target Index ในไฟล์ .mind)
const targetsData = [
  // --- SET 1: 10 รูปแรก ---

  // ID 0: 1.png
  {
    id: 0,
    title: { th: "ประวัติวัดพระธาตุดอยสุเทพ (๒๔๙๕)", en: "History of Wat Phra That Doi Suthep (1952)" },
    desc: { 
      th: "หนังสือประวัติวัดพระธาตุดอยสุเทพ จังหวัดเชียงใหม่ จัดพิมพ์โดยกรมศิลปากร สำหรับงานกฐินพระราชทาน ณ วัดพระธาตุดอยสุเทพ เมื่อปี พ.ศ. ๒๔๙๕", 
      en: "History of Wat Phra That Doi Suthep, Chiang Mai. Published by the Fine Arts Department for the Royal Kathin Ceremony in 1952." 
    },
    audio: { th: "/assets/ar/00_doisuthep_th.mp3", en: "/assets/ar/00_doisuthep_en.mp3" },
    links: [ { label: "Book Info", url: "รออัพเดท", icon: "📖" },
             { label: "Google Map", url: "https://maps.app.goo.gl/TL1ok1vGnFJanCcZA", icon: "🗺️" }
     ]
  },
  // ID 1: 2.png
  {
    id: 1,
    title: { th: "ตำนานพระธาตุดอยสุเทพ (๒๔๗๒)", en: "Legend of Phra That Doi Suthep (1929)" },
    desc: { 
      th: "หนังสือตำนานพระธาตุดอยสุเทพ พิมพ์เป็นอนุสรณ์ในงานพระราชทานเพลิงศพ เจ้าหญิงจามรีวงศ์ (พ.ศ. ๒๔๗๒) ผู้สืบเชื้อสายเจ้านายฝ่ายเหนือ", 
      en: "The Legend of Phra That Doi Suthep. Commemorative volume for the royal cremation of Princess Chamariwong (1929), a Northern Thai royal descendant." 
    },
    audio: { th: "/assets/ar/01_chamari_th.mp3", en: "/assets/ar/01_chamari_en.mp3" },
    links: [ { label: "ข้อมูลเพิ่มเติม", url: "https://culture-reader-cnx.netlify.app/book/98", icon: "🌐" },
             { label: "Google Map", url: "https://maps.app.goo.gl/TL1ok1vGnFJanCcZA", icon: "🗺️" }
      ]
  },
  // ID 2: 3.png
  {
    id: 2,
    title: { th: "ร่ำดอยสุเทพ เชียงใหม่", en: "Doi Suthep Chronicles, Chiang Mai" },
    desc: { 
      th: "เอกสารโบราณบันทึกด้วยอักษรธรรมล้านนา (ตั๋วเมือง) สะท้อนภูมิปัญญา ความเชื่อ และพุทธศาสนาในท้องถิ่นที่สืบทอดมายาวนาน", 
      en: "Ancient manuscript written in Lanna Dhamma script, reflecting local wisdom, beliefs, and Buddhist heritage handed down through generations." 
    },
    audio: { th: "/assets/ar/02_lanna_script_th.mp3", en: "/assets/ar/02_lanna_script_en.mp3" },
    links: [ { label: "รออัพเดท", url: "รออัพเดท", icon: "📜" },
             { label: "Google Map", url: "https://maps.app.goo.gl/TL1ok1vGnFJanCcZA", icon: "🗺️" } ]
  },
  // ID 3: 4.png
  {
    id: 3,
    title: { th: "ตำนานพระบรมธาตุดอยสุเทพ (๒๔๘๒)", en: "Legend of Doi Suthep Relic (1939)" },
    desc: { 
      th: "พิมพ์ในงานพระราชทานเพลิงศพ นายพลตรี เจ้าแก้วนวรัฐ เจ้าผู้ครองนครเชียงใหม่องค์สุดท้าย ณ เมรุวัดสวนดอก เมื่อ พ.ศ. ๒๔๘๒", 
      en: "Published for the royal cremation of Major General Chao Kaew Nawarat, the last Ruler of Chiang Mai, at Wat Suan Dok in 1939." 
    },
    audio: { th: "/assets/ar/03_kaewnawarat_th.mp3", en: "/assets/ar/03_kaewnawarat_en.mp3" },
    links: [ { label: "ข้อมูลเพิ่มเติม", url: "https://culture-reader-cnx.netlify.app/book/36", icon: "📜" },
             { label: "Google Map", url: "https://maps.app.goo.gl/TL1ok1vGnFJanCcZA", icon: "🗺️" } ]
  },
  // ID 4: 5.png
  {
    id: 4,
    title: { th: "ตำนานพระธาตุดอยสุเทพ นครเชียงใหม่ ", en: "Legend of Phra That Doi Suthep, Chiang Mai" },
    desc: { 
      th: "หนังสือเก่ารวบรวมตำนานและประวัติความเป็นมาของพระธาตุศักดิ์สิทธิ์คู่บ้านคู่เมืองเชียงใหม่ พร้อมภาพถ่ายเจดีย์ศิลปะล้านนาในอดีต", 
      en: "Vintage collection of legends and history of the sacred pagoda of Chiang Mai, featuring historical photographs of Lanna architecture." 
    },
    audio: { th: "/assets/ar/04_stupa_th.mp3", en: "/assets/ar/04_stupa_en.mp3" },
    links: [ { label: "ข้อมูลเพิ่มเติม", url: "https://culture-reader-cnx.netlify.app/book/57", icon: "📜" },
             { label: "Google Map", url: "https://maps.app.goo.gl/TL1ok1vGnFJanCcZA", icon: "🗺️" } ]
  },
  // ID 5: 6.png
  {
    id: 5,
    title: { th: "ตำนานพระธาตุดอยสุเทพ", en: "Legend of Phra That Doi Suthep" },
    desc: { 
      th: "จัดพิมพ์ขึ้นเป็นที่ระลึกในงานพระราชทานเพลิงศพ  เจ้าพงศ์อินทร์ และ        นางจันทร์สม  ณ  เชียงใหม่ ", 
      en: "Commemorative publication for the royal cremation of Chao Phong In and Nang Jansom in Chiang Mai." 
    },
    audio: { th: "/assets/ar/05_insignia_th.mp3", en: "/assets/ar/05_insignia_en.mp3" },
    links: [ { label: "ข้อมูลเพิ่มเติม", url: "รอัพเดท", icon: "📜" },
             { label: "Google Map", url: "https://maps.app.goo.gl/TL1ok1vGnFJanCcZA", icon: "🗺️" } ]
  },
  // ID 6: 7.png
  {
    id: 6,
    title: { th: "พระพุทธรูป 7 ปาง วัดพระสิงห์ (๒๔๘๖)", en: "7 Buddha Postures at Wat Phra Singh (1943)" },
    desc: { 
      th: "ประวัติการสร้างพระพุทธรูปประจำวัน (พระ 7 ปาง) ณ วัดพระสิงห์ จังหวัดเชียงใหม่ เมื่อวันที่ 23 มกราคม พ.ศ. 2486", 
      en: "History of the creation of the 7 Daily Buddha images at Wat Phra Singh, Chiang Mai, on January 23, 1943." 
    },
    audio: { th: "/assets/ar/06_phrasingh_th.mp3", en: "/assets/ar/06_phrasingh_en.mp3" },
    links: [ { label: "ข้อมูลเพิ่มเติม", url: "https://culture-reader-cnx.netlify.app/book/38", icon: "📜" },
             { label: "Google Map", url: "https://maps.app.goo.gl/pceEE956jcng3Lpr6", icon: "🗺️" }  ]
  },
  // ID 7: 8.png
  {
    id: 7,
    title: { th: "ตำนานวัดเจดีย์หลวงและอินทขิล", en: "Wat Chedi Luang & Inthakhin Legend" },
    desc: { 
      th: "พิมพ์เมื่อ พ.ศ. 2482 กล่าวถึงประวัติวัดเจดีย์หลวงวรวิหาร และตำนานเสาอินทขิล (เสาหลักเมือง) ซึ่งเป็นศูนย์รวมจิตใจของชาวเชียงใหม่", 
      en: "Published in 1939, covers the history of Wat Chedi Luang and the Legend of Inthakhin (City Pillar), the spiritual center of Chiang Mai people." 
    },
    audio: { th: "/assets/ar/07_chediluang_th.mp3", en: "/assets/ar/07_chediluang_en.mp3" },
    links: [ { label: "ข้อมูลเพิ่มเติม", url: "https://culture-reader-cnx.netlify.app/book/34", icon: "📜" },
             { label: "Google Map", url: "https://maps.app.goo.gl/7s4KZWFmsPjEsogz8", icon: "🗺️" } ]
  },
  // ID 8: 9.png
  {
    id: 8,
    title: { th: "ชุมชนโบราณในเขตล้านนา", en: "Ancient Communities in Lanna" },
    desc: { 
      th: "หนังสือประกอบการสัมมนาล้านนาคดีศึกษา โดยใช้แผนที่และภาพถ่ายทางอากาศในการศึกษาแหล่งโบราณคดีและการตั้งถิ่นฐานในอดีต", 
      en: "A study of ancient Lanna communities using aerial photography and maps to analyze archaeological sites and historical settlements." 
    },
    audio: { th: "/assets/ar/08_ancient_map_th.mp3", en: "/assets/ar/08_ancient_map_en.mp3" },
    links: [ { label: "ข้อมูลเพิ่มเติม", url: "https://culture-reader-cnx.netlify.app/book/44", icon: "📖" } ]
  },
  // ID 9: 10.png
  {
    id: 9,
    title: { th: "หมายประกาศเป็นข้อบังคับสำหรับซื้อชายช้าง", en: "Proclamation on Buying Male Elephants" },
    desc: { 
      th: "มายประกาศเป็นข้อบังคับสำหรับซื้อขายช้าง” เป็นหนังสือหายากที่สำคัญ ออกโดยข้าหลวงใหญ่รักษาราชการมณฑลลาวเฉียง", 
      en: "Proclamation on Buying and Selling Elephants is a rare and important book issued by the Chief Commissioner of the Chiang Mai Monthon." 
    },
    audio: { th: "/assets/ar/09_elephant_th.mp3", en: "/assets/ar/09_elephant_en.mp3" },
    links: [ { label: "ข้อมูลตำรา", url: "รออัพเดท", icon: "🐘" } ]
  },

  // --- SET 2: 6 รูปใหม่ (11.png - 16.png) ---

  // ID 10: 11.png (วัดมหาโพธาราม/เจ็ดยอด)
  {
    id: 10,
    title: { th: "ตำนานวัดมหาโพธาราม (วัดเจ็ดยอด)", en: "Legend of Wat Mahaphotharam (Jed Yod)" },
    desc: { 
      th: "หนังสืออนุสรณ์งานศพ พระครูอุดมโพธิคุณ (๒๕๑๘) กล่าวถึงประวัติวัดเจ็ดยอด สถานที่สังคายนาพระไตรปิฎกครั้งที่ 8 ของโลก", 
      en: "Cremation volume for Phra Kru Udom Phothikhun (1975), detailing the history of Wat Jed Yod, the site of the 8th World Buddhist Council." 
    },
    audio: { th: "/assets/ar/10_jedyod_th.mp3", en: "/assets/ar/10_jedyod_en.mp3" },
    links: [ { label: "ข้อมูลเพิ่มเติม", url: "https://culture-reader-cnx.netlify.app/book/59", icon: "📜" },
             { label: "Google Map", url: "https://maps.app.goo.gl/Qw9Ep9auEC21yyyEA", icon: "🗺️" }  
    ]
  },

  // ID 11: 12.png (วัดอุโมงค์)
  {
    id: 11,
    title: { th: "ประวัติวัดอุโมงค์", en: "History of Wat Umong" },
    desc: { 
      th: "ประวัติวัดอุโมงค์ (สวนพุทธธรรม) โบราณสถานที่มีอุโมงค์ลอดใต้เจดีย์ อันเป็นเอกลักษณ์สำคัญของเชียงใหม่", 
      en: "History of Wat Umong (Garden of Dhamma), a unique ancient temple in Chiang Mai known for its meditation tunnels under the stupa." 
    },
    audio: { th: "/assets/ar/11_umong_th.mp3", en: "/assets/ar/11_umong_en.mp3" },
    links: [ { label: "ข้อมูลเพิ่มเติม", url: "https://culture-reader-cnx.netlify.app/book/63", icon: "📜" },
             { label: "Google Map", url: "https://maps.app.goo.gl/HFMjcbaHUvJAbY368", icon: "🗺️" }
    ]
  },

  // ID 12: 13.png (หอสมุดแห่งชาติ)
  {
    id: 12,
    title: { th: "ที่ระลึกในพิธีเปิด หอสมุดแห่งชาติ รัชมังคลาภิเษก เชียงใหม่", en: "Commemorative Book for the Opening of the National Library of Chiang Mai" },
    desc: { 
      th: "ที่ระลึกพิธีเปิดหอสมุดแห่งชาติ เชียงใหม่ (๒๕๓๒) แหล่งรวบรวมภูมิปัญญาและเอกสารสำคัญของล้านนา สร้างเพื่อเฉลิมพระเกียรติรัชมังคลาภิเษก", 
      en: "Commemorative book for the opening of the Chiang Mai National Library (1989), a repository of Lanna wisdom and archives." 
    },
    audio: { th: "/assets/ar/12_library_th.mp3", en: "/assets/ar/12_library_en.mp3" },
    links: [ { label: "ข้อมูลเพิ่มเติม", url: "https://culture-reader-cnx.netlify.app/book/61", icon: "📜" },
             { label: "Google Map", url: "https://maps.app.goo.gl/YHbWgrP6M5byakDa9", icon: "🗺️" } 
    ]
  },

  // ID 13: 14.png (วัดสวนดอก)
  {
    id: 13,
    title: { th: "วัดสวนดอกและสุสานหลวง", en: "Wat Suan Dok & Royal Cemetery" },
    desc: { 
      th: "หนังสือโดยกรมศิลปากร (๒๕๕๙) ว่าด้วยประวัติวัดสวนดอก และกู่เจ้านายฝ่ายเหนือ สถานที่บรรจุอัฐิของเจ้าผู้ครองนครเชียงใหม่", 
      en: "Published by the Fine Arts Dept (2016), covering the history of Wat Suan Dok and the Royal Cemetery of the Rulers of Chiang Mai." 
    },
    audio: { th: "/assets/ar/13_suandok_th.mp3", en: "/assets/ar/13_suandok_en.mp3" },
    links: [ { label: "ข้อมูลเพิ่มเติม", url: "รออัพเดท", icon: "📜" },
             { label: "Google Map", url: "https://maps.app.goo.gl/HTct1CwwCNfjWyZq8", icon: "🗺️" } 
    ]
  },

  // ID 14: 15.png (วัดพระสิงห์)
  {
    id: 14,
    title: { th: "วัดพระสิงห์วรมหาวิหาร", en: "Wat Phra Singh Woramahawihan" },
    desc: { 
      th: "พระอารามหลวงชั้นเอก ศูนย์รวมจิตใจชาวเชียงใหม่ ที่ประดิษฐานพระพุทธสิหิงค์ พระพุทธรูปศักดิ์สิทธิ์คู่บ้านคู่เมือง", 
      en: "A first-class Royal Monastery and spiritual center of Chiang Mai, housing the sacred Phra Phuttha Sihing Buddha image." 
    },
    audio: { th: "/assets/ar/14_phrasingh_th.mp3", en: "/assets/ar/14_phrasingh_en.mp3" },
    links: [ { label: "ข้อมูลเพิ่มเติม", url: "รออัพเดท", icon: "📜" },
             { label: "Google Map", url: "https://maps.app.goo.gl/h5or7e3nKji77mxd6", icon: "🗺️" }
    ]
  },

  // ID 15: 16.png (กำแพงเมือง)
  {
    id: 15,
    title: { th: "กำแพงเมืองเชียงใหม่ (๒๕๒๙)", en: "Chiang Mai City Walls (1986)" },
    desc: { 
      th: "หนังสือรวบรวมภาพและประวัติศาสตร์ของกำแพงเมืองและคูเมืองเชียงใหม่ ปราการสำคัญที่ปกป้องนครเวียงพิงค์มายาวนานกว่า 700 ปี", 
      en: "Collection of history and images of the Chiang Mai City Walls and Moat, the fortress that has protected the city for over 700 years." 
    },
    audio: { th: "/assets/ar/15_wall_th.mp3", en: "/assets/ar/15_wall_en.mp3" },
    links: [ { label: "ข้อมูลเพิ่มเติม", url: "https://culture-reader-cnx.netlify.app/book/42", icon: "📜" },
             { label: "Google Map", url: "https://maps.app.goo.gl/YHbWgrP6M5byakDa9", icon: "🗺️" }
    ]
  }
];

const ArGuidePage = () => {
  const [started, setStarted] = useState(false);
  const [lang, setLang] = useState('th'); // th | en
  const [activeTargetId, setActiveTargetId] = useState(null); // เก็บ ID ของรูปที่สแกนเจอ

  const audioRef = useRef(null);
  const sceneRef = useRef(null);

  // --- 1. เริ่มต้นใช้งาน (User Interaction Start) ---
  const handleStart = () => {
    // Hack: เล่นและหยุดทันทีเพื่อให้ Browser อนุญาตให้เล่นเสียงผ่าน JS ได้ในภายหลัง
    if (audioRef.current) {
      audioRef.current.play().catch(() => {}).then(() => audioRef.current.pause());
    }
    setStarted(true);
  };

  // --- 2. ฟังก์ชันจัดการเมื่อเจอเป้าหมาย (Target Found) ---
  const handleTargetFound = (index) => {
    // ถ้าเป็น Target เดิมที่กำลังเล่นอยู่แล้ว ไม่ต้องทำอะไร (หรือถ้าจะให้เริ่มใหม่ก็ลบ condition นี้)
    if (activeTargetId === index) return;

    console.log(`Found Target Index: ${index}`);
    setActiveTargetId(index);
  };

  // --- 3. Effect สำหรับเล่นเสียงเมื่อ activeTargetId เปลี่ยน ---
  useEffect(() => {
    if (activeTargetId === null) {
      // ถ้าไม่มี Target (หรือถูกปิด) ให้หยุดเสียง
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
      }
      return;
    }

    // โหลดข้อมูลและเล่นเสียง
    const currentData = targetsData.find(t => t.id === activeTargetId);
    if (currentData && audioRef.current) {
      const src = lang === 'th' ? currentData.audio.th : currentData.audio.en;
      audioRef.current.src = src;
      audioRef.current.play().catch(e => console.error("Audio play failed:", e));
    }

  }, [activeTargetId, lang]); // รันเมื่อ ID เปลี่ยน หรือ ภาษาเปลี่ยน

  // --- 4. ฟังก์ชันปิดการแสดงผล (Manual Close) ---
  const handleCloseContent = () => {
    setActiveTargetId(null); // Reset ค่า จะทำให้เสียงหยุดตาม Effect ข้อ 3
  };

  // --- 5. A-Frame Event Listener Binding ---
  useEffect(() => {
    if (!started) return;

    const sceneEl = sceneRef.current;
    
    // ฟังก์ชันแปะ Event Listener ให้กับ entity ทั้งหมด
    const setupEvents = () => {
      targetsData.forEach((target) => {
        const el = document.querySelector(`#target-${target.id}`);
        if (el) {
          el.addEventListener('targetFound', () => handleTargetFound(target.id));
          // ตัด targetLost ออก เพื่อให้เล่นค้างไว้
        }
      });
    };

    // รอให้ Scene โหลดเสร็จก่อน bind events
    if (sceneEl) {
      if (sceneEl.hasLoaded) {
        setupEvents();
      } else {
        sceneEl.addEventListener('loaded', setupEvents);
      }
    }
  }, [started]);

  // ดึงข้อมูลปัจจุบันมาแสดงผล
  const activeData = activeTargetId !== null ? targetsData.find(t => t.id === activeTargetId) : null;

  return (
    <div className="flex flex-col h-[100dvh] w-screen bg-neutral-900 font-sans overflow-hidden">
      
      {/* --- LAYER 1: START SCREEN (Modal) --- */}
      {!started && (
        <div className="absolute inset-0 z-[999] bg-black flex justify-center items-center p-4">
          <div className="bg-white text-gray-800 p-8 rounded-3xl text-center max-w-sm w-full shadow-2xl">
            <h2 className="text-2xl font-bold mb-4 text-blue-600">📷 AR Scanner</h2>
            <p className="mb-6 text-gray-600">กรุณาเปิดเสียง หรือสวมหูฟังเพื่อประสบการณ์ที่ดีที่สุด</p>
            <button 
              className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-10 rounded-full text-lg shadow-lg active:scale-95 transition-transform" 
              onClick={handleStart}
            >
              Start Camera
            </button>
          </div>
        </div>
      )}

      {/* --- UI STRUCTURE: TOP - CENTER (AR) - BOTTOM --- */}
      {started && (
        <>
          {/* === TOP SECTION: SETTINGS & MENU === */}
          <div className="flex-none bg-white text-gray-900 p-4 rounded-b-3xl z-20 shadow-md flex justify-between items-center h-20">
            <div className="font-bold text-lg text-blue-800">🏛️ THE CULTURE</div>
            <div className="flex gap-2">
              <button 
                onClick={() => setLang(lang === 'th' ? 'en' : 'th')}
                className="bg-gray-200 text-gray-800 px-3 py-1 rounded-full text-sm font-bold border border-gray-300"
              >
                {lang.toUpperCase()}
              </button>
              <button className="bg-gray-200 text-gray-800 p-2 rounded-full text-sm">
                ⚙️
              </button>
            </div>
          </div>

          {/* === MIDDLE SECTION: SQUARE AR VIEWPORT === */}
          {/* ใช้ flex-grow เพื่อดันพื้นที่ และจัดกล้องให้อยู่ตรงกลาง */}
          <div className="flex-grow relative flex items-center justify-center bg-black z-0 overflow-hidden">
            
            {/* กรอบสี่เหลี่ยมสำหรับบอก User ว่าเล็งตรงนี้ */}
            <div className="w-[80vw] h-[80vw] max-w-[400px] max-h-[400px] border-4 border-white/30 rounded-2xl z-10 pointer-events-none relative">
                <div className="absolute top-0 left-0 w-4 h-4 border-t-4 border-l-4 border-white -mt-1 -ml-1"></div>
                <div className="absolute top-0 right-0 w-4 h-4 border-t-4 border-r-4 border-white -mt-1 -mr-1"></div>
                <div className="absolute bottom-0 left-0 w-4 h-4 border-b-4 border-l-4 border-white -mb-1 -ml-1"></div>
                <div className="absolute bottom-0 right-0 w-4 h-4 border-b-4 border-r-4 border-white -mb-1 -mr-1"></div>
            </div>

            {/* A-FRAME SCENE: ซ่อนอยู่ข้างหลัง แต่แสดงผลทะลุขึ้นมา */}
            {/* MindAR จะพยายามขยายเต็มจอ เราใช้ CSS masking หรือปล่อยให้เต็มจอแต่ UI บังเอาไว้ */}
            <div className="absolute inset-0 w-full h-full">
               <a-scene 
                ref={sceneRef}
                mindar-image="imageTargetSrc: /assets/ar/targets.mind; uiScanning: no; filterMinCF:0.0001; filterBeta: 0.001;" 
                color-space="sRGB" 
                renderer="colorManagement: true, physicallyCorrectLights" 
                vr-mode-ui="enabled: false" 
                device-orientation-permission-ui="enabled: false"
                embedded // ใช้ embedded เพื่อให้ style css ควบคุมขนาดได้บ้าง (แต่ MindAR มักจะ override)
                style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 0}}
              >
                <a-camera position="0 0 0" look-controls="enabled: false"></a-camera>

                {/* สร้าง Entity ตามจำนวน Targets ใน Data */}
                {targetsData.map((target) => (
                  <a-entity key={target.id} id={`target-${target.id}`} mindar-image-target={`targetIndex: ${target.id}`}>
                    {/* แสดงโมเดล 3D หรือ Plane เมื่อเจอ (Visual Feedback ในกล้อง) */}
                    <a-plane color="cyan" opacity="0.5" height="1" width="1" rotation="0 0 0" animation="property: opacity; to: 0.1; dir: alternate; dur: 1000; loop: true"></a-plane>
                  </a-entity>
                ))}
              </a-scene>
            </div>
          </div>

          {/* === BOTTOM SECTION: LINKS & CONTENT === */}
          <div className="flex-none bg-white min-h-[30vh] p-6 rounded-t-3xl z-20 shadow-[0_-5px_20px_rgba(0,0,0,0.2)] flex flex-col items-center text-center">
            
            {activeData ? (
              // Case 1: เจอเป้าหมาย (แสดงข้อมูล + ลิงก์)
              <div className="w-full animate-[slideUp_0.3s_ease-out]">
                {/* ปุ่มปิด */}
                <div className="flex justify-end mb-2">
                   <button onClick={handleCloseContent} className="text-gray-400 hover:text-red-500">
                     ✕ Close
                   </button>
                </div>

                <h3 className="text-2xl font-bold text-gray-800 mb-2">{activeData.title[lang]}</h3>
                <p className="text-gray-600 mb-6 line-clamp-3">{activeData.desc[lang]}</p>
                
                {/* External Links Area */}
                <div className="grid grid-cols-2 gap-3 w-full">
                  {activeData.links.map((link, idx) => (
                    <a 
                      key={idx}
                      href={link.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center justify-center gap-2 bg-blue-50 text-blue-700 py-3 rounded-xl font-semibold hover:bg-blue-100 transition-colors"
                    >
                      <span>{link.icon}</span> {link.label}
                    </a>
                  ))}
                </div>

                {/* Audio Status Indicator */}
                <div className="mt-4 flex items-center justify-center gap-2 text-xs text-green-600">
                  <span className="relative flex h-3 w-3">
                    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
                    <span className="relative inline-flex rounded-full h-3 w-3 bg-green-500"></span>
                  </span>
                  Playing Audio...
                </div>
              </div>
            ) : (
              // Case 2: ยังไม่เจอเป้าหมาย (Show Hints)
              <div className="h-full flex flex-col justify-center items-center text-gray-400">
                <div className="text-4xl mb-2">🔍</div>
                <p>ส่องกล้องไปที่รูปภาพเพื่อรับชมข้อมูล</p>
                <p className="text-xs mt-2">Point camera at the image target</p>
              </div>
            )}
          </div>
        </>
      )}

      {/* Audio Element (Hidden) */}
      <audio ref={audioRef} preload="auto" />

      {/* Global Styles for Animations */}
      <style jsx>{`
        @keyframes slideUp {
          from { transform: translateY(20px); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
      `}</style>
    </div>
  );
};

export default ArGuidePage;